<template>
    <div>
        {{ $t('notification.userRoleChanged', { 
            actor: $_.get(activity, 'actorUser.name'), 
            userName: $_.get(activity, 'payload.userName'),
            oldRoleName: $_.get(activity, 'payload.oldRoleName'),
            newRoleName: $_.get(activity, 'payload.newRoleName')
        }) }}
    </div>
</template>
<script>
import Vue from "vue";

export default Vue.extend({
    name: "UserRoleChanged",
    props: {
        activity: {
            type: Object,
            default: () => ({}),
        },
    },
});
</script>

<style scoped lang="scss"></style>

